module.exports = __webpack_public_path__ + "media/images/logo/logo_arkea-145f81616cd06c8775ecb65afc4a2b27.svg";